module.exports = __webpack_public_path__ + "static/img/xiao_shop.5ca5d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/xiao_shop.jpg
// module id = 58
// module chunks = 31